import * as React from 'react';

const DocumentSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="document_svg__eds-icon--document_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="document_svg__eds-icon--document_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 6h2.5L16 3.5V6zM5 3v18h14V7h-4V3H5zM4 22V2h12l4 4v16H4z"
        />
        <g
            id="document_svg__eds-icon--document_lines"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M8 9h8v1H8zM8 12h8v1H8zM8 15h8v1H8z" />
        </g>
    </svg>
);

DocumentSvg.displayName = 'DocumentSvg';
export default DocumentSvg;
